import { Typography } from '@mui/material';
import React from 'react';
import { StandardDialog } from 'shared-components/components';
import { DocumentType } from '../Interface';

interface UnViewedAutoDocDialogProps {
  documentList: DocumentType[];
  hasUnapprovedAttachment: boolean;
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const UnViewedAutoDocDialog = ({
  documentList,
  hasUnapprovedAttachment,
  open,
  onClose,
  onSubmit,
}: UnViewedAutoDocDialogProps): JSX.Element => {
  const unviewedDocuments = documentList.some((doc) => !doc.viewed);
  return (
    <StandardDialog
      title="Confirm Submission"
      open={open && (unviewedDocuments || hasUnapprovedAttachment)}
      onClose={onClose}
      onSubmit={onSubmit}
      submitText="confirm & submit"
      closeText="Cancel">
      <Typography paddingY={1}>You are about to submit the prescription and other documents.</Typography>
      <Typography paddingY={1}>
        Please confirm that you have reviewed and approved all editable documents (including any simulation request
        attachment) and that they are ready for submission.
      </Typography>
    </StandardDialog>
  );
};

export default UnViewedAutoDocDialog;
